import { render, staticRenderFns } from "./UpdateConcept.vue?vue&type=template&id=564a5eea&scoped=true"
import script from "./UpdateConcept.vue?vue&type=script&lang=js"
export * from "./UpdateConcept.vue?vue&type=script&lang=js"
import style0 from "./UpdateConcept.vue?vue&type=style&index=0&id=564a5eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564a5eea",
  null
  
)

export default component.exports